import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class ProgramYearVisualizeObjectivesRoute extends Route {
  @service currentUser;
  @service store;

  beforeModel(transition) {
    this.currentUser.requireNonLearner(transition);
  }

  model(params) {
    return this.store.findRecord('program-year', params.program_year_id);
  }

  /**
   * Prefetch related data to limit network requests
   */
  async afterModel(model) {
    const store = this.store;
    const cohort = await model.get('cohort');
    const courses = cohort.hasMany('courses').ids();

    const promises = [
      model.get('program'),
      model.get('competencies'),
      model.get('programYearObjectives'),
    ];
    if (courses.length) {
      promises.push(store.query('course-objective', { filters: { courses } }));
      promises.push(store.query('session-objective', { filters: { courses } }));
    }

    return Promise.all(promises);
  }
}
